import { render, staticRenderFns } from "./TermsOfUseWrapper.vue?vue&type=template&id=c33dfb14&"
import script from "./TermsOfUseWrapper.vue?vue&type=script&lang=js&"
export * from "./TermsOfUseWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports